const Handlebars = require('handlebars')

// =============================================================
// Handlebars templates
// =============================================================
// => Partial: tooltip of airports
Handlebars.registerPartial('airports', '{{airportsList}}')
// => Partial: tooltip of alimentation
Handlebars.registerPartial('alimentation', '{{alimentationOptions}}')

// =============================================================
// Handlebars registerHelper => 'Statements'
// =============================================================
Handlebars.registerHelper('ifSet', function(index, value, options) {
  if (index == value){
    return options.fn(this)
  } else {
    return null
  }
})

Handlebars.registerHelper('compare', function(lvalue, rvalue, options) {

  if (arguments.length < 3)
    throw new Error('Handlerbars Helper "compare" needs 2 parameters')

  const operator = options.hash.operator || '=='

  const operators = {
    '==' (l, r) { return l == r },
    '===' (l, r) { return l === r },
    '!=' (l, r) { return l != r },
    '<' (l, r) { return l < r },
    '>' (l, r) { return l > r },
    '<=' (l, r) { return l <= r },
    '>=' (l, r) { return l >= r },
    'typeof' (l, r) { return typeof l == r },
  }

  if (!operators[operator])
    throw new Error(`Handlerbars Helper "compare" does not know the operator ${operator}`)

  const result = operators[operator](lvalue, rvalue)

  if (result) {
    return options.fn(this)
  } else {
    return options.inverse(this)
  }

})

// =============================================================
// Handlebars registerHelper => 'formatTime'
// Helper for parsing time
// =============================================================
Handlebars.registerHelper('formatTime', function(time) {
  return `${time.substring(0, 2)}:${time.substring(2, 4)}`
})

// =============================================================
// Handlebars registerHelper => 'each_upto'
// =============================================================
Handlebars.registerHelper('each_upto', function(ary, max, options) {
  if (!ary || ary.length == 0)
    return options.inverse(this)

  const result = [ ]
  for (let i = 0; i < max && i < ary.length; ++i)
    result.push(options.fn(ary[i]))
  return result.join('')
})



// WEBPACK FOOTER //
// ./src/helpers/handlebars.js